// Utilities for building canonical URLs

const ROOT = (typeof window !== 'undefined' && (window as any).__TCARDS_ROOT__) || 'tcards.org';

// Resolve scheme for handle subdomains. Defaults to https, but can be
// overridden while wildcard TLS is not yet issued.
function getHandleScheme(): 'http' | 'https' {
  // Prefer runtime override injected into window for maximum flexibility
  const winScheme = (typeof window !== 'undefined' && (window as any).__TCARDS_SCHEME__) as string | undefined;
  if (winScheme === 'http' || winScheme === 'https') return winScheme;

  // Vite client build-time env (replaced at build time)
   
  const viteEnv = (typeof import.meta !== 'undefined' ? (import.meta as any).env : undefined) as Record<string, unknown> | undefined;
  const viteScheme = (viteEnv?.VITE_HANDLE_SUBDOMAIN_SCHEME as string | undefined) || undefined;
  if (viteScheme === 'http' || viteScheme === 'https') return viteScheme;

  // Node/SSR env fallback
  const nodeScheme = (typeof process !== 'undefined' && (process.env?.VITE_HANDLE_SUBDOMAIN_SCHEME as string | undefined)) || undefined;
  if (nodeScheme === 'http' || nodeScheme === 'https') return nodeScheme;

  return 'https';
}

function stripWww(label: string): string {
  const v = String(label || '').trim().toLowerCase();
  return v.startsWith('www.') ? v.slice(4) : v;
}

export function canonicalCardUrl(handle: string, username?: string): string {
  const h = stripWww(handle);
  const u = (username || '').trim();
  const root = stripWww(String(ROOT));
  const scheme = getHandleScheme();
  return `${scheme}://${h}.${root}${u ? `/${u}` : ''}`;
}

export function canonicalSubdomain(handle: string): string {
  return `${stripWww(handle)}.${stripWww(String(ROOT))}`;
}

// Return the canonical origin (protocol + host) for a given handle.
export function canonicalCardOrigin(handle: string): string {
  const h = stripWww(handle);
  const root = stripWww(String(ROOT));
  const scheme = getHandleScheme();
  return `${scheme}://${h}.${root}`;
}
